import React, { useEffect, useState, useRef } from "react";
import { logDev } from "../../utils/logger.js";
import { useLanguage } from "../../context/LanguageContext";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useMediaQuery, Box } from "@mui/material";

import { moments } from "../../constants/moments.js";
import { makeCategoryLabels } from "../../constants/categories.js";
import SnackbarFeedback from "../../pages/SnackbarFeedback";
import ItemRow from "./ItemRow"; // ou ton chemin réel
import { useSnackbar } from "../../hooks/useSnackbar";
import ParticipationSwitch from "./ParticipationsSwitch.js";
import { useFetchMenuJournalier } from "../../hooks/useFetchMenuJournalier";
import { useMenu } from "../../context/MenuContext.js";

import { printMenuJournalier } from "../../utils/printMenuUtils.js";
import { getCategoryColor } from "../../constants/categories.js";

const MenusJournalier = ({
  info,
  t,
  groupeActif,
  groupeId,
  isAdmin,
  totalContactsPeriodeDominante 
}) => {
  const [articles, setArticles] = useState([]);
  const { snackbar, setSnackbar, bottomNavHeight, showSnackbar } = useSnackbar();
  const isMobile = useMediaQuery("(max-width:600px)");
  const labels = makeCategoryLabels(t);

const { locale } = useLanguage();
  
  const [expandedAccordions, setExpandedAccordions] = useState({
    0: false,
    1: false,
    2: false
  });
  
  const menuContext = useMenu();
  const { itemsMenus } = menuContext;
  const dateIso = info.date?.split("T")[0];
  const [participation, setParticipation] = useState(
  info.participationUtilisateurs?.[dateIso] || false
);

  const canEdit = isAdmin || participation === true;

  const [repas, setRepas] = useState(itemsMenus[dateIso] || info.repas || []);

  const fetchedDates = useRef(new Set());

  useFetchMenuJournalier({
    jour: new Date(info.date),
    groupeId,
    fetchedDates,
    setItems: setRepas,
    setItemsMenus: menuContext.setItemsMenus
  });

  useEffect(() => {
    if (itemsMenus[dateIso]) {
      setRepas(itemsMenus[dateIso] || []);
    }
  }, [itemsMenus, dateIso]);

  // Charger les articles pour l'autocomplete
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/articles?groupeId=${groupeId}`)
      .then(res => setArticles(res.data))
      .catch(err => logDev("Erreur articles", err));
  }, [groupeId]);

  // Ajouter un item
  const addItem = (momentIndex, catIndex) => {
    const newRepas = [...repas];
    newRepas[momentIndex].categories[catIndex].items.push({
      draftName: "",   // 🔥 texte libre
      quantity: 0,
      articleId: null,
      saved: false
    });
    setRepas(newRepas);
  };

  // Modifier un item
  const updateItem = (momentIndex, catIndex, itemIndex, field, value) => {
    const newRepas = [...repas];
    newRepas[momentIndex].categories[catIndex].items[itemIndex][field] = value;
    setRepas(newRepas);
  };

  // Supprimer un item
  const removeItem = async (momentIndex, catIndex, itemIndex) => {
    const item = repas[momentIndex].categories[catIndex].items[itemIndex];

  // 🔥 1) Suppression backend si l’item existe
  if (item._id) {
    try {
      await axios.delete(`${process.env.REACT_APP_API}/items/${item._id}`);

      showSnackbar({
        message: t("ItemDeleted"),
        severity: "success",
        emoji: groupeActif?.emoji
      });
    } catch (err) {
      logDev("Erreur suppression item", err);
      showSnackbar({
        message: t("ErrorDeletingItem"),
        severity: "error",
        emoji: groupeActif?.emoji
      });
      return;
    }
  }
    
    // 🔥 2) Suppression locale
    const newRepas = [...repas];
    newRepas[momentIndex].categories[catIndex].items.splice(itemIndex, 1);
    setRepas(newRepas);

    // 🔥 3) Mise à jour du MenuContext (sinon l’item revient)
  menuContext.setItemsMenus(prev => ({
    ...prev,
    [dateIso]: newRepas
  }));
};

  const saveItem = async (item, momentIndex, catIndex, itemIndex) => {

  // 🔥 VALIDATION : quantité obligatoire
  if (item.quantity === "" || item.quantity === 0) {
    showSnackbar({
      message: t("QuantityRequired"),
      severity: "warning",
      emoji: groupeActif?.emoji
    });

    return;
  }

  let articleId = item.articleId;

  // 🔥 SI L’ARTICLE N’EXISTE PAS → ON LE CRÉE
  if (!articleId) {
    // 🛑 VALIDATION : nom obligatoire
  if (!item.draftName || item.draftName.trim() === "") {
    showSnackbar({
      message: t("ItemRequired"),
      severity: "error",
      emoji: groupeActif?.emoji
    });

    return;
  }

    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/articles`, {
        name: item.draftName,   // 🔥 ICI : draftName, pas name
        groupe: groupeId
      });

      articleId = res.data._id;

      // on met à jour l’item localement
      updateItem(momentIndex, catIndex, itemIndex, "articleId", articleId);

      // 🟢 SNACKBAR ARTICLE CRÉÉ
      showSnackbar({
        message: t("ItemCreated"),
        severity: "success",
        emoji: groupeActif?.emoji
      });

    } catch (err) {
      logDev("Erreur création article", err);
      return;
    }
  }

    // 🔥 SI L’ITEM N’EXISTE PAS → ON LE CRÉE
  if (!item._id) {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/items`, {
        quantity: item.quantity,
        articleId,
        categorie: repas[momentIndex].categories[catIndex].categorie,
        moment: repas[momentIndex].moment,
        groupe: groupeId,
        menuId: info._id,
        repasId: repas[momentIndex]._id
      });

      updateItem(momentIndex, catIndex, itemIndex, "_id", res.data._id);
      updateItem(momentIndex, catIndex, itemIndex, "saved", true);

      showSnackbar({
      message: t("MenuUpdated"),
      severity: "success",
      emoji: groupeActif?.emoji
    });

      return;

    } catch (err) {
      logDev("Erreur création item", err);
      return;
    }
  }

  // 🔥 SINON → ON MET À JOUR L’ITEM EXISTANT
  axios.put(`${process.env.REACT_APP_API}/items/${item._id}`, {
    quantity: item.quantity,
    articleId,
    categorie: repas[momentIndex].categories[catIndex].categorie,
    moment: repas[momentIndex].moment,
    groupe: groupeId
  })
  .then(() => {
    updateItem(momentIndex, catIndex, itemIndex, "saved", true);

    showSnackbar({
      message: t("MenuUpdated"),   // ou t("ItemUpdated")
      severity: "success",
      emoji: groupeActif?.emoji
    });
  })
  .catch(err => logDev("Erreur sauvegarde item", err));
};

const buildPrintableStructure = (repas) => {
  const result = {};

  repas.forEach(r => {
    const moment = r.moment; // "Matin", "Midi", "Soir"
    result[moment] = {};

    r.categories.forEach(c => {
      result[moment][c.categorie] = c.items; // ici items = objets complets dans le frontend
    });
  });

  return result;
};

console.log("RAW info.date =", info.date);
console.log("PARSED DATE =", new Date(info.date));
console.log(
  "FORMATTED =",
  new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(new Date(info.date))
);


  return (
    <Box sx={{ mb: 4 }}>
      {/* PRINT */}
      <Button
        variant="outlined"
        onClick={() => {
          printMenuJournalier(
            {
              date: info.date,
              total: totalContactsPeriodeDominante,
              menuId: info._id
            },
            buildPrintableStructure(repas),
            {
              nom: groupeActif?.nom,
              emoji: groupeActif?.emoji,
              couleur: groupeActif?.couleur
            },
            t,
            articles
          );
        }}
      >
        🖨️ {t("PrintThisDay")}
      </Button>

      {/* SWITCH PARTICIPATION */}
      {isAdmin && (
      <ParticipationSwitch
        dateIso={dateIso}
        menuId={info._id} 
        participationInitiale={info.participationUtilisateurs?.[dateIso] || false}
        t={t}
        showSnackbar={showSnackbar}
      />
    )}

    <Button
      variant="text"
      onClick={() => {
        const allOpen = Object.values(expandedAccordions).every(v => v === true);

      setExpandedAccordions({
        0: !allOpen,
        1: !allOpen,
        2: !allOpen
      });
    }}
    sx={{ mt: 2, mb: 1 }}
  >
    {Object.values(expandedAccordions).every(v => v === true)
      ? t("CollapseAll")
      : t("ExpandAll")}
    </Button>

      {/* REPAS */}
      {repas.map((r, momentIndex) => (
        <Box
          key={momentIndex}
          sx={{
            maxWidth: "100%",     // 🔥 largeur max comme ton CustomAccordion
            width: "100%",     // responsive
            mx: "auto",        // 🔥 centre horizontalement
            mb: 2              // espace entre les accordéons
          }}
        >
          <Accordion
            expanded={expandedAccordions[momentIndex]}
            onChange={() => {
              setExpandedAccordions(prev => ({
              ...prev,
              [momentIndex]: !prev[momentIndex]
            }));
          }}
        >

        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{t(`Moment_${r.moment}`)}</Typography>
        </AccordionSummary>

          <AccordionDetails>
            {Array.isArray(r.categories) && (
              r.categories.map((c, catIndex) => (
              <Box 
              key={catIndex}
              sx={{
                mb: 3,
                pl: 2,
                py: 1.5,
                borderRadius: "6px",
                backgroundColor: getCategoryColor(c.categorie)
              }}
              >
              <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                mb: 1
              }}
              >
            {labels[c.categorie]}
              </Typography>

            {c.items.map((item, itemIndex) => {

              // 🔥 1) Récupérer les articleId déjà utilisés dans cette catégorie
              const usedArticleIds = c.items
                .filter((_, idx) => idx !== itemIndex) // exclure l’item en cours
                .map(i => i.articleId)
                .filter(Boolean); // enlever null

              // 🔥 2) Filtrer les articles pour ne PAS proposer ceux déjà utilisés
              const filteredArticles = articles.filter(a => !usedArticleIds.includes(a._id));

            return (
              <ItemRow
              item={item}
              articles={filteredArticles}
              isMobile={isMobile}
              saved={item.saved}
              t={t}
              canEdit={canEdit}

              // 🔥 Quand l’utilisateur tape du texte libre
              onChangeDraftName={(value) => {
                updateItem(momentIndex, catIndex, itemIndex, "draftName", value);
              }}

              // 🔥 Quand l’utilisateur sélectionne un article existant
              onChangeArticle={(value) => {
              if (!value) {
                // saisie libre → articleId null
                updateItem(momentIndex, catIndex, itemIndex, "articleId", null);
              return;
              }

            // sélection dans la liste
            updateItem(momentIndex, catIndex, itemIndex, "articleId", value?._id || null);
            updateItem(momentIndex, catIndex, itemIndex, "draftName", value.name || "");
          }}

          onChangeQuantity={(value) => {
            updateItem(momentIndex, catIndex, itemIndex, "quantity", value);
          }}

          onSave={() => saveItem(item, momentIndex, catIndex, itemIndex)}
          onDelete={() => removeItem(momentIndex, catIndex, itemIndex)}
        />
      );
    })}

    {canEdit && (
    <Button
      startIcon={<AddIcon />}
      onClick={() => addItem(momentIndex, catIndex)}
      sx={{ mt: 1 }}
    >
    {t("AddAnItem")}
    </Button>
    )}
      </Box>
      ))
    )}
    </AccordionDetails>
  </Accordion>
    </Box>
      ))
      }

      <SnackbarFeedback
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        bottomNavHeight={bottomNavHeight}
        emoji={snackbar.emoji}
      />
    </Box>
  );
};

export default MenusJournalier;
